import api from '@lib/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchData } from '../../tools/_fetch-data-helper';

export const fetchVisual = createAsyncThunk('visualSlice/fetchVisual', async (_, thunkApi) => {
  return fetchData(api.urlFlats, thunkApi);
});

const initialState = {
  visual: null,
  fetchError: false,
  activeQueue: null,
};

export const visualSlice = createSlice({
  name: 'visualSlice',
  initialState,
  reducers: {
    handleChangeActiveQueue: (state, action) => {
      state.activeQueue = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchVisual.fulfilled, (state, action) => {
        state.visual = action.payload;
      })
      .addCase(fetchVisual.rejected, state => {
        state.fetchError = true;
      });
  },
});

export const { handleChangeActiveQueue } = visualSlice.actions;

export const visualSelector = state => state.visual.visual;
export const fetchErrorSelector = state => state.visual.fetchError;
export const activeQueueSelector = state => state.visual.activeQueue;

export default visualSlice.reducer;
